module.exports = __webpack_public_path__ + "static/avg_heatmap-5508a0cca2577890a38013d4c8955957.gif";